import { FaWhatsapp } from "react-icons/fa";
import { contact as sharedContact } from "../data/contact";

function buildWhatsAppUrl(contact) {
  if (contact.whatsapp) {
    return contact.whatsapp;
  }

  const primaryPhone = contact.phones?.[0] || "";
  const normalizedPhone = primaryPhone.replace(/[^\d+]/g, "");

  return normalizedPhone
    ? `https://wa.me/${normalizedPhone.replace(/^\+/, "")}`
    : "#";
}

function FloatingWhatsAppButton({ contact = sharedContact }) {
  const whatsappUrl = buildWhatsAppUrl(contact);

  return (
    <a
      aria-label="Chat with Fortress Safe on WhatsApp"
      className="group fixed bottom-[calc(env(safe-area-inset-bottom)+1rem)] right-4 z-40 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_18px_45px_rgba(14,27,43,0.24)] ring-1 ring-white/20 transition duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-gold sm:bottom-6 sm:right-6 sm:h-16 sm:w-16"
      href={whatsappUrl}
      rel="noreferrer"
      target="_blank"
    >
      <span className="absolute inset-0 rounded-full bg-white/10 opacity-0 transition duration-300 group-hover:opacity-100" />

      <FaWhatsapp className="relative h-7 w-7 sm:h-8 sm:w-8" />
    </a>
  );
}

export default FloatingWhatsAppButton;